const getDefaultMessagesState = () => ({
  messages: [],
  readMessageLogId: '',
  readMessageSchema: '',
});

export default {
  state: getDefaultMessagesState(),
  actions: {
    async GET_MESSAGES(context, payload) {
      const request = {
        url: `/api/v4/people/parent/messages/${payload.offset}/${payload.limit}`,
      };
      const mutation = 'UPDATE_MESSAGES';
      const options = {
        request,
        mutation,
      };

      await context.dispatch('MAKE_LAZY_LOAD_GET_REQUEST', options);
    },

    async SET_MESSAGE_AS_READ(context, payload) {
      const request = {
        url: '/api/v4/people/messages/read',
        parameters: {
          logId: payload.logId,
          schema: payload.schema,
        },
      };
      const mutation = 'UPDATE_MESSAGE_READ';
      const options = {
        request,
        mutation,
      };

      await context.dispatch('MAKE_POST_REQUEST', options);
    },
  },

  mutations: {
    UPDATE_MESSAGES(state, payload) {
      state.messages = state.messages.concat(payload);
    },

    UPDATE_MESSAGE_READ(state, payload) {
      console.log(payload);
    },

    RESET_MESSAGES_STATE(state) {
      Object.assign(state, getDefaultMessagesState());
    },
  },

  getters: {
    messages(state) {
      return state.messages;
    },
  },
};
